var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNutritionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87993 12.32C7.77993 12.68 7.59993 13.01 7.31993 13.28C6.44993 14.15 5.04993 14.15 4.16993 13.28C3.28993 12.41 3.29993 11.01 4.16993 10.14C4.44993 9.86 4.77993 9.68 5.11993 9.58C5.05993 8.72 5.34993 7.85 5.98993 7.2C6.62993 6.55 7.51993 6.25 8.36993 6.33C8.47993 5.98 8.64993 5.66 8.92993 5.38C9.79993 4.51 11.2099 4.51 12.0799 5.38C12.9499 6.25 12.9499 7.66 12.0799 8.54C11.7999 8.82 11.4699 9 11.1199 9.1C11.1999 9.94 10.9099 10.82 10.2499 11.47C9.58993 12.12 8.72993 12.41 7.87993 12.34V12.32Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4199 7.02L2.43994 15.01",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5599 7.46C21.5599 7.72 21.4999 7.96 21.3999 8.18L20.3399 11.51C20.1999 11.99 19.7599 12.35 19.2299 12.35C18.6999 12.35 18.2699 11.99 18.1199 11.51H18.0199C17.8699 11.99 17.4399 12.35 16.9099 12.35C16.3799 12.35 15.9399 11.99 15.7999 11.51L14.7299 8.18C14.6299 7.96 14.5699 7.71 14.5699 7.46C14.5699 6.5 15.3499 5.72 16.3099 5.72C17.2699 5.72 18.0599 6.5 18.0599 7.46C18.0599 6.5 18.8399 5.72 19.7999 5.72C20.7599 5.72 21.5499 6.5 21.5499 7.46H21.5599Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.07 7.46C18.07 7.46 17.82 4.94 18.94 3.36",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1799 8.95V9.12",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.95 8.95V9.12",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3642 16.6175L17.4417 16.8865C17.4827 17.0636 17.4942 17.2402 17.4764 17.4163C17.4723 17.4838 17.4565 17.5424 17.4379 17.595C17.1069 18.5181 14.9518 18.1857 12.2727 19.3787C10.5981 20.128 8.8438 20.4054 7.82608 19.7699C7.61676 19.6368 7.43169 19.463 7.2915 19.2458C7.25439 19.1834 7.21444 19.1151 7.18043 19.0439C6.47182 17.5612 7.20156 15.3838 10.4662 14.3336C13.6687 13.3057 16.7245 14.8979 17.3642 16.6175Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4389 16.8805L17.7826 18.0568L17.9494 18.7566C16.925 20.5 15.5878 19.4554 12.7426 20.7278C10.6176 21.6778 8.81188 22.1983 8.10611 20.7216L8.11204 20.7187L7.2887 19.2399C7.42889 19.457 7.60803 19.6337 7.82328 19.7639C8.841 20.3995 10.5953 20.1221 12.2699 19.3728C14.9549 18.1769 17.11 18.5094 17.4351 17.589C17.4537 17.5364 17.4666 17.472 17.4736 17.4104C17.4914 17.2343 17.4799 17.0577 17.4389 16.8805Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8791 17.1495C15.223 16.9851 15.3686 16.5731 15.2042 16.2291C15.0398 15.8852 14.6278 15.7397 14.2839 15.904C13.9399 16.0684 13.7944 16.4805 13.9587 16.8244C14.1231 17.1683 14.5352 17.3139 14.8791 17.1495Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4034 15.6735L10.9515 17.7881",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98301 16.3713L8.60673 18.202",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionIcon);
export default __webpack_public_path__ + "static/media/nutrition_icon.535525c8ceadfd5d86943c0c188987f4.svg";
export { ForwardRef as ReactComponent };